import React, { useMemo } from "react"

import { useApp } from "../../hooks/useApp"
import { useRoutes } from "../../hooks/useRoutes"
import { useTemplate } from "../../hooks/useTemplate"
import { useAccount } from "../../hooks/useAccount"

export const withArticle = Component => ({ name = "Article", article, articles: allArticles, type = "article" }) => {
  const { activeSubscription, profile } = useAccount()
  const { edgeNormaliser, setRegister } = useApp()
  const { routeResolver } = useRoutes()
  const templates = useTemplate()

  const template = useMemo(() => templates[type], [type, templates])

  const categories = edgeNormaliser(template?.categories)

  const navigation = categories?.map((category: any) => ({
    title: category?.title,
    count: edgeNormaliser(category?.articles)?.length,
    items: edgeNormaliser(allArticles)
      ?.filter((article: any) => article?.category?.slug?.current === category?.slug?.current)
      ?.sort((a: any, b: any) => (a.title >= b.title ? 1 : -1))
      ?.reduce(
        (articles, article) => (!articles?.find(({ slug }) => slug?.current === article?.slug?.current) ? [...articles, article] : [...articles]),
        edgeNormaliser(category?.articles)
      )
      ?.map((item: any) => ({
        ...item,
        active: item?.slug?.current === article?.slug?.current,
        url: routeResolver({ item, type: type }),
      })),
  }))

  const accountType = useMemo(() => [activeSubscription ? "subscribed" : "", profile ? "members" : "", "public"]?.filter(Boolean), [
    profile,
    activeSubscription,
  ])
  const handleRegister = () => setRegister((prevState: boolean) => !prevState)

  const orderedArticles = [].concat(...navigation?.map(({ items }) => items || []))
  const articleIndex = orderedArticles?.findIndex(({ slug: { current } }) => current === article?.slug?.current)
  const next = orderedArticles[articleIndex + 1]
  const nextArticleVisible = useMemo(() => !next?.visibility || accountType?.includes(next?.visibility), [next, accountType])

  Component.displayName = name
  return (
    <Component
      {...article}
      navigation={navigation}
      next={next}
      locales={template}
      nextArticleVisible={nextArticleVisible}
      handleRegister={handleRegister}
    />
  )
}
